module.exports = __webpack_public_path__ + "static/media/LaurenRiddle-resume.b37d685f.pdf";